import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/logo.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Vue logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Go Games")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ClassicButton = _resolveComponent("ClassicButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_HelloWorld = _resolveComponent("HelloWorld")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_link, { to: "/Games" }, {
      default: _withCtx(() => [
        _createVNode(_component_ClassicButton, null, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_HelloWorld, { msg: "Welcome to Your Vue.js + TypeScript App" })
  ]))
}